import { render, staticRenderFns } from "./Consumer.vue?vue&type=template&id=43a83d81&"
import script from "./Consumer.vue?vue&type=script&lang=js&"
export * from "./Consumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports